import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetNameSpace } from '../../../store/constants'

export default (client_id,senderId) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrl2 + '/config-namespace-fb-all';
    var paramBody = {
        "query":{
            "search":{
                "client-id" : client_id,
                "sender-id" : ""
            },
            "page":1,
            "page-size":5000,
            "order-by":1,
            "order":"ASC",

        }
    };

    if(senderId !== undefined){
        paramBody = {
            "query":{
                "search":{
                    "client-id" : client_id,
                    "sender-id" : senderId
                },
                "page":1,
                "page-size":5000,
                "order-by":1,
                "order":"ASC",
                "client-id" : client_id
            }
        };
    }
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await fetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
    }
    dispatch({ type: GetNameSpace, data: fromJS(data) });
};